import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { css } from 'styled-components'
import classNames from 'classnames'

import ErrorMessage from '../UI/blocks/ErrorMessage'

export default function InfoInput({
  icon = '',
  placeholder = 'Label',
  borderBottom = false,
  birthdate = false,
  textarea = false,
  error = '',
  label,
  showErrorMessage = true,
  disabled = false,
  language = 'english',
  ...props
}) {
  const [v, setV] = useState(props.value || '')
  const [errorMessage, setErrorMessage] = useState(error)

  useEffect(() => {
    setErrorMessage(error)
  }, [error])

  useEffect(() => {
    if (props.value !== undefined) {
      setV(props.value)
    }
  }, [props.value])

  function changeV(e) {
    let { value } = e.target
    if (birthdate) {
      var reg = /^\d+$/
      value = value
        .split('')
        .filter(i => i !== '-')
        .join('')
      console.log(value)
      if (!reg.test(value) && value !== '') return

      let tempV = value.split('')
      if (tempV.length > 8) return
      if (tempV.length > 1) {
        tempV.splice(2, 0, '-')
      }
      if (tempV.length > 4) {
        tempV.splice(5, 0, '-')
      }
      setV(tempV.join(''))
      return
    }
    setV(value)

    if (language === 'english') {
      value = value.replace(/[^A-Za-z]/gi, '')
      setV(value)
    }
  }

  function onBlur(e) {
    let { type, value, required } = e.target
    var pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/

    if (required && !value) {
      setErrorMessage('This field is required')
      return
    }

    if (type === 'email') {
      if (!value.match(pattern)) {
        setErrorMessage(
          'Please enter provide email address. Ex : email@gmail.com'
        )
        return
      }
    }

    setErrorMessage('')
  }

  return (
    <>
      <StyledInfoInput
        {...props}
        className={classNames('styledInputColor')}
        borderBottom={borderBottom}
      >
        <div>
          <i className={'icon icon-' + icon}></i>
        </div>
        <div>
          {textarea ? (
            <textarea
              placeholder={placeholder}
              value={v}
              onChange={changeV}
              onBlur={onBlur}
              rows={3}
              {...props}
            />
          ) : (
            <input
              placeholder={placeholder}
              disabled={disabled && disabled}
              value={v}
              onChange={changeV}
              onBlur={onBlur}
              {...props}
            />
          )}
        </div>
      </StyledInfoInput>
      <StyledError>
        {errorMessage && showErrorMessage && (
          <ErrorMessage>{errorMessage}</ErrorMessage>
        )}
      </StyledError>
    </>
  )
}

const StyledInfoInput = styled.div`
  padding: 8px 38px;
  display: flex;
  align-items: center;
  gap: 18px;
  margin: 10px;
  min-height: 40px;
  input[type='date']::-webkit-inner-spin-button,
  input[type='date']::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}

  ${({ borderBottom }) =>
    borderBottom &&
    css`
      ${'' /* border-bottom: 1px solid #9a9ca6; */}
    `}

  & > div {
    &:first-of-type {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 15px;

      & > i {
        width: 15px;
        height: 15px;
        opacity: 0.8;
      }
    }

    &:last-of-type {
      flex: 1;
      min-width: 0;

      & > input,
      & > textarea {
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        background-color: transparent;
        width: 100%;
        border: none;
        outline: none;
        padding: 0;
        margin: 0;

        &::placeholder {
          color: rgba(255, 255, 255, 0.6);
          font-weight: 300;
        }

        &:focus {
          outline: none;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      & > textarea {
        resize: vertical;
        min-height: 60px;
        line-height: 1.4;
      }
    }
  }
`

const StyledError = styled.div`
   {
    padding: 0 38px;
  }
`
